import React from 'react';
import type { SimulationMatrixPayload } from '@interactive-room';

const GRID_BG: Record<string, string | undefined> = {
  math_5mm: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M 20 0 L 0 0 0 20' fill='none' stroke='%23e2e8f0' stroke-width='1'/%3E%3C/svg%3E")`,
  dot_grid: `radial-gradient(circle, #cbd5e1 1px, transparent 1px)`,
  blank: undefined,
};

export function PrintExploraSimuladorBlock({ payload }: { payload: SimulationMatrixPayload }) {
  const workspace = payload.workspace;
  const gridBackground = workspace ? GRID_BG[workspace.gridType] : undefined;
  const gridSize = workspace?.gridType === 'dot_grid' ? '12px 12px' : undefined;
  const workspaceLabel =
    workspace?.gridType === 'math_5mm'
      ? 'Espacio de desarrollo / cálculos:'
      : 'Espacio de desarrollo / notas:';

  return (
    <div className="print-sim-matrix print:break-inside-avoid">
      <div className="print-sim-matrix__head">
        <h3 className="print-sim-matrix__title">{payload.title}</h3>
        <p className="print-sim-matrix__instruction">{payload.instructionText}</p>
      </div>

      <div className="print-sim-matrix__table-wrap">
        <table className="print-sim-matrix__table">
          <thead>
            <tr>
              {payload.headers.map((header, i) => (
                <th key={i} className="print-sim-matrix__th">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {payload.rows.map((row) => (
              <tr key={row.id} className="print-sim-matrix__tr">
                {row.cells.map((cell, cellIdx) => (
                  <td key={cellIdx} className="print-sim-matrix__td">
                    {cell.isHiddenInput ? (
                      <span className="print-sim-matrix__input" aria-hidden>
                        {cell.placeholderLabel ? (
                          <span className="print-sim-matrix__placeholder">{cell.placeholderLabel}</span>
                        ) : null}
                      </span>
                    ) : (
                      cell.value
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {workspace && (
        <div className="print-sim-matrix__workspace">
          <span className="print-sim-matrix__workspace-label">
            {workspaceLabel}
          </span>
          <div
            className="print-sim-matrix__workspace-area"
            style={{
              height: `${workspace.heightRows * 24}px`,
              backgroundImage: gridBackground,
              backgroundSize: gridSize,
            }}
            aria-hidden
          />
        </div>
      )}
    </div>
  );
}
